// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zxrz","importantInfo":"styles_importantInfo__2Tie8"};